<template>
    <article-layout>
        <div class="subpage-top">
            <h1>Puppy's</h1>
            <router-link to="/#puppy">Terug</router-link>
        </div>
        <p>
          Een pup is meer dan enkel schattigheid. Het opvoeden van een jonge pup is een langdurig proces waarin vaak veel doorzettingsvermogen gevraagd wordt van de baasjes. Het is daarom belangrijk om zich goed voor te bereiden op dit proces zodat men nadien met volle teugen kan genieten van een rustige en gehoorzame hond. De vzw staat toekomstige en huidige baasjes graag hierin bij om mogelijke twijfels of vragen niet onbeantwoord te laten. Om deze taak goed te vervullen, nodigen wij geïnteresseerden graag uit voor een informatief gesprek via onderstaand formulier.
        </p>
        <form action="/send-pup" method="post">
          <div class="field">
            <div class="control has-icons-right">
              <input class="input is-large" name="name" type="text" placeholder="Naam" value="" v-model="name" required>
              <span class="icon is-small is-right">
                <invalid-input v-if="!isValidName" class="invalid-input"></invalid-input>
                <valid-input v-if="isValidName" class="valid-input"></valid-input>
              </span>
            </div>
            <div class="control has-icons-right">
              <input class="input is-large" name="email" type="text" placeholder="E-mail" value="" v-model="email" required>
              <span class="icon is-small is-right">
                <invalid-input v-if="!isValidEmail" class="invalid-input"></invalid-input>
                <valid-input v-if="isValidEmail" class="valid-input"></valid-input>
              </span>
            </div>
            <div class="control">
                <input name="phone" class="input is-large" type="text" placeholder="Telefoon" value="">
            </div>
            <div class="control has-icons-right">
              <input name="place" class="input is-large" type="text" placeholder="Woonplaats" value="" v-model="place" required>
                <span class="icon is-small is-right">
                  <invalid-input v-if="!isValidPlace" class="invalid-input"></invalid-input>
                  <valid-input v-if="isValidPlace" class="valid-input"></valid-input>
                </span>
            </div>
            <div class="control">
              <label>Interesse in</label>
              <select name="interest">
                <option value="Geen voorkeur">Geen voorkeur</option>
                <option value="Reu">Reu</option>
                <option value="Teef">Teef</option>
              </select>
            </div>
            <div class="data-policy">Uw gegevens worden enkel gebruikt door ons om u te contacteren. Wij geven nooit gegevens door aan derden.</div>
            <div class="control btn">
              <button type="submit" class="button is-primary" :disabled="isValidForm">Verzenden</button>
            </div>
          </div>
        </form>
    </article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
import InvalidInput from "vue-material-design-icons/AlertCircleOutline.vue";
import ValidInput from "vue-material-design-icons/CheckCircleOutline.vue";
export default {
    name: "PuppyDetailed",
    components: {
        ArticleLayout, InvalidInput, ValidInput
    },
    data: function () {
      return {
        name: "",
        email: "",
        place: ""
      }
    },
    computed: {
      isValidName: function() {
        if (this.name.length > 2) {
          return true;
        } else {
          return false;
        }
      },
      isValidEmail: function() {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          return true;
        } else {
          return false;
        }
      },
      isValidPlace: function() {
        if (this.place.length > 2) {
          return true;
        } else {
          return false;
        }
      },
      isValidForm: function () {
        return !(this.isValidName && this.isValidEmail && this.isValidPlace);
      }
    }
}
</script>

<style scoped>
    p {
        margin-top: 2vh;
        margin-bottom: 2vh;
    }

    .material-design-icon.invalid-input {
      /* font-size: 1rem; */
      color: #700100;
    }
    .material-design-icon.valid-input {
      /* font-size: 1rem; */
      color: #007001;
    }
    
    .control input[type=text],
    textarea, label {
        border: none;
        border-bottom: 2px solid #006f70;
        border-radius: 0;

        background: none;
        color: #016F70;
        box-shadow: none;

        font-family: "Poppins";
        font-size: 26px;

        margin-bottom: 20px;
        transition: color 1s ease, border 1s ease;
        padding-bottom: 0px;
    }

    .control input[type=text]::placeholder,
    textarea::placeholder {
        color: #006f70;
        font-size: 26px;
    }
    
    .control label {
        color: #006f70;
        font-size: 26px;
        border-bottom: 0;
        margin-left: calc(0.625em - 1px);
    }
    
    .control select {
        border: 0px;
        outline: 0px;
        padding-left: 10px;
        padding-right: 10px;
        border-bottom: 2px solid #006f70;
        border-radius: 0;
        
        color: #006f70;
        font-family: "Poppins";
        font-size: 26px;

        margin-bottom: 20px;
        margin-left: 10px;
        transition: color 1s ease, border 1s ease;
        padding-bottom: 0px;
    }
    
    .control select:focus {
        outline: none;
    }

    .control input[type=text]:focus,
    textarea:focus {
        color: #99C5C4;
        outline: none;
        box-shadow: none;
        border-bottom: 2px solid #99C5C4;
    }
    
    textarea {
        resize: none;
    }
    .btn {
        display: flex;
        flex-direction: column;
        align-content: center;
    }
    button.is-primary, button.is-primary:disabled {
        margin: 5vh auto 0vh auto;
        color: #f5f5f5;
        border-radius: 0;
        background-color: #1d7d7e;
        font-family: "Poppins";
        font-weight: 400;
        font-size: 1.3em;
        transition: color .3s ease, background-color .3s ease;
    }
    button.is-primary:hover {
        background-color: #f5f5f5;
        color: #016F70;
    }
    .data-policy {
      font-size: .8rem;
    }
</style>